import React from "react";
import { Card } from "@/components/ui/card";

const ACCENTS = {
  emerald: {
    text: "text-emerald-400",
    ring: "shadow-[0_0_28px_rgba(16,185,129,0.15)]",
    border: "border-emerald-500/20",
    bg: "bg-emerald-500/5",
    print: "print-accent-emerald",
  },
  rose: {
    text: "text-rose-400",
    ring: "shadow-[0_0_28px_rgba(244,63,94,0.15)]",
    border: "border-rose-500/20",
    bg: "bg-rose-500/5",
    print: "print-accent-rose",
  },
  amber: {
    text: "text-amber-400",
    ring: "shadow-[0_0_28px_rgba(245,158,11,0.15)]",
    border: "border-amber-500/20",
    bg: "bg-amber-500/5",
    print: "print-accent-amber",
  },
  blue: {
    text: "text-sky-400",
    ring: "shadow-[0_0_28px_rgba(14,165,233,0.15)]",
    border: "border-sky-500/20",
    bg: "bg-sky-500/5",
    print: "",
  },
  violet: {
    text: "text-violet-400",
    ring: "shadow-[0_0_28px_rgba(139,92,246,0.15)]",
    border: "border-violet-500/20",
    bg: "bg-violet-500/5",
    print: "",
  },
};

export const KpiCard = ({
  label,
  value,
  subtext,
  accent = "emerald",
  icon: Icon,
  testId,
}) => {
  const a = ACCENTS[accent] || ACCENTS.emerald;
  return (
    <Card
      data-testid={testId}
      className={`kpi-card print-card bg-slate-900/70 ${a.border} ${a.ring} border p-5 relative overflow-hidden`}
    >
      <div className={`absolute inset-0 ${a.bg} pointer-events-none`} />
      <div className="relative flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 text-xs font-semibold tracking-wider uppercase text-slate-400">
            {Icon && <Icon className="h-3.5 w-3.5" />}
            <span>{label}</span>
          </div>
          <div
            className={`mt-2 font-display font-extrabold tracking-tight font-mono-tab text-2xl sm:text-3xl ${a.text} ${a.print}`}
          >
            {value}
          </div>
          {subtext && (
            <div className="mt-1 text-xs text-slate-500 font-mono-tab">
              {subtext}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};
